module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am652-12d76f9d1d9726a6f34991de6308b931.jpg";